import React from 'react'
import { Trans } from '@mc/i18n'
import {
  AITermsLink,
  PrivacyLink,
  SpeechPolicyLink,
  TermsLink,
} from '../../../../components/links'

export const BundleLegal = ({ className = '' }: { className?: string }) => (
  <p className={className}>
    <Trans
      i18nKey='emailCapture.standaloneBundle'
      ns='@mc/legal'
      components={{
        terms: <TermsLink />,
        'ai-terms': <AITermsLink />,
        privacy: <PrivacyLink />,
        'speech-policy': <SpeechPolicyLink />,
      }}
    />
  </p>
)
